// 独立模块(落地页一类的)api地址
// 暴露接口需要用到的地址
// 接口配置config
let protocol = window.location.protocol;
let hostname = window.location.hostname;
if (process.env.NODE_ENV === 'production') {
    // 生产环境
    hostname = window.location.hostname;
    // console.log = (() => {});
    console.log('无情无耻无理取闹');
} else {
    // protocol = `${protocol}//dingdangyou.cn`;
    // 开发环境
    // console.log('无情无耻无理取闹');
    // console.log=(()=>{});
}
// 官网模块接口
const phoneReg = `${protocol}//sdkapi.dingdangyou.cn/api/v1/wap/reg/mobile`; // 手机号注册
const accountFastLogin = `${protocol}//sdkapi.dingdangyou.cn/api/v1/wap/reg/account`; // 一键注册

const accountLogin = `${protocol}//sdkapi.dingdangyou.cn/api/v1/wap/login/account`; // 登录
const phoneFastLogin = `${protocol}//sdkapi.dingdangyou.cn/api/v1/wap/login/mobile`; // 手机快捷登录


const findPassWord = `${protocol}//sdkapi.dingdangyou.cn/api/v1/password/new`; // 手机快捷登录

const addSubAccount = `${protocol}//sdkapi.dingdangyou.cn/api/v1/login/addSub`; // 手机快捷登录

const bindMobile = `${protocol}//sdkapi.dingdangyou.cn/api/v1/bind/mobile`; // 绑定手机

const childAccount = `${protocol}//log.dingdangyou.cn/api/v1/sdkLogin/index`; // 子账号登录
const getYzm = `${protocol}//api.dingdangyou.cn/api/v1/send/code`; // 发送短信
const makeGame = `${protocol}//sdkapi.dingdangyou.cn/api/v1/contact/subscribe`; // 预约游戏
const landing = `${protocol}//sdkapi.dingdangyou.cn/api/v1/landing/page`; // 落地页
export default {
    phoneReg,
    accountLogin,
    getYzm,
    makeGame,
    landing,
    phoneFastLogin,
    accountFastLogin,
    childAccount,
    findPassWord,
    addSubAccount,
    bindMobile
}